// @ts-ignore Legacy browser utility script.
import '../../../../assets/js/number-utils.js';
// @ts-ignore Legacy browser utility script.
import '../../../../assets/js/dependency-loader.js';
// @ts-ignore Legacy browser utility script.
import '../../../../assets/js/url-state-contracts.js';
// @ts-ignore Legacy browser utility script.
import '../../../../assets/js/url-state.js';
// @ts-ignore Legacy browser utility script.
import '../../../../assets/js/export-utils.js';
// @ts-ignore Legacy browser utility script.
import '../../../../assets/js/pdf-export-utils.js';

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(value);
}

export function formatPercent(value: number): string {
  return `${value.toFixed(1)}%`;
}

export function parseContractState<T extends Record<string, unknown>>(contractId: string, defaults: T): T {
  const decoded = window.UrlState?.getStateFromSearchWithContract(window.location.search, 'd', contractId);
  if (!decoded) {
    return defaults;
  }

  return { ...defaults, ...(decoded as Partial<T>) };
}

export function createContractShareUrl(
  canonicalPath: string,
  contractId: string,
  state: Record<string, unknown>
): string {
  const payload = window.UrlStateContracts?.encode(contractId, state) ?? state;
  const encoded = window.btoa(JSON.stringify(payload));
  const path = canonicalPath === '/' || canonicalPath.endsWith('/') ? canonicalPath : `${canonicalPath}/`;
  return `${window.location.origin}${path}?d=${encoded}`;
}

export function exportRowsToCsv(headers: string[], rows: Array<Array<string | number>>, filename: string): void {
  if (window.ExportUtils?.buildCsvContent && window.ExportUtils?.downloadCsv) {
    const csvContent = window.ExportUtils.buildCsvContent(headers, rows);
    window.ExportUtils.downloadCsv(csvContent, filename);
    return;
  }

  const normalizedRows = [headers, ...rows].map((row) => row.map((cell) => String(cell)));
  const csvContent = normalizedRows.map((row) => row.join(',')).join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
}

export async function copyToClipboard(value: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    return false;
  }
}

type PdfReportPayload = {
  title: string;
  subtitle?: string;
  summaryLeft: string[];
  summaryRight: string[];
  headers: string[];
  rows: Array<Array<string | number>>;
  filename: string;
  footerText?: string;
};

export async function exportPdfReport(payload: PdfReportPayload): Promise<boolean> {
  try {
    if (window.ensurePdfDependencies) {
      await window.ensurePdfDependencies();
    }

    const pdfUtils = window.PdfExportUtils;
    if (!pdfUtils) {
      return false;
    }

    const document = pdfUtils.createBrandedPdf(payload.title, payload.subtitle);
    const summaryBottom = pdfUtils.addSummaryColumns(
      document,
      payload.summaryLeft,
      payload.summaryRight,
      45
    );

    pdfUtils.addDataTable(document, {
      startY: summaryBottom + 8,
      head: [payload.headers],
      body: payload.rows
    });

    pdfUtils.addStandardFooter(document, payload.footerText);
    document.save(payload.filename);
    return true;
  } catch {
    return false;
  }
}
